import React from 'react';
import { ReactComponent as DollarSignMonitor } from 'src/assets/images/dollar-sign-monitor.svg';
import { ReactComponent as RecurringCalendar } from 'src/assets/images/recurring-calendar.svg';
import { ReactComponent as SellDashboard } from 'src/assets/images/sell-dashboard.svg';
import TRP from 'src/components/Shared/TRP/TRP';
import { default as config, default as env } from 'src/config/config';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import styles from './styles.module.scss';

const BASE_PATH = env?.basePath ?? '';

export const AutoSellWhatsNext: React.FC = () => (
  <div className={styles['exit-container']}>
    <div>
      <div className={styles['exit-heading']}>What's next?</div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            className={'e2e-confirm-another-trade'}
            exitLocation={`${config.url}${BASE_PATH}/automatic`}
            heading={'Add Another Automatic Transaction'}
            id={'confirm-another-trade'}
            subHeading={
              'Scheduling recurring exchanges makes it easy to automatically adjust your portfolio.'
            }
          >
            <RecurringCalendar />
          </ConfirmationExitBox>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            className={'e2e-confirm-one-time-trade'}
            exitLocation={`${config.url}/usis/transactions/landing`}
            heading={'Make A One-Time Trade'}
            id={'confirm-one-time-trade'}
            subHeading={
              <div>
                Buy, sell, or exchange using your <TRP /> accounts.
              </div>
            }
          >
            <DollarSignMonitor />
          </ConfirmationExitBox>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            className={'e2e-confirm-view-dashboard'}
            exitLocation={`${config.url}/usis/my-accounts`}
            heading={'View Your Dashboard'}
            id={'confirm-view-dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
          >
            <SellDashboard />
          </ConfirmationExitBox>
        </div>
      </div>
    </div>
  </div>
);

export default AutoSellWhatsNext;
